import axios from "axios";
import React, { useEffect, useState } from "react";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import checkImg from "./../../assets/images/check.png";
import warningImg from "./../../assets/images/exclamation.png";
import "./Register.css";
import { useSearchParams } from "react-router-dom";
import LoadingView from "./../components/LoadingView/LoadingView";
import SearchAutocomplete from "../../components/SearchAutoComplete/SearchAutoComplete";

function Register(props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [dob, setDob] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [location, setLocation] = useState("");

  const apiAddress = process.env.REACT_APP_SECRET;

  const [userNameFound, setUserNameFound] = useState(false);
  const [emailFound, setEmailFound] = useState(false);
  const [success, setSuccess] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [maxDate, setMaxDate] = useState(today);

  //phone number validation start
  const [Phone, setPhone] = useState("");

  const [error, setError] = useState("");

  const validatePhoneNumber = () => {
    const phonePattern = /^[0-9]{10,11}$/;

    if (!phonePattern.test(phoneNumber)) {
      setError("Please enter a valid 10 or 11-digit phone number.");
      return false;
    }

    setError("");
    return true;
  };

  //phone number validation end

  const validateEmail = (props) => {
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailPattern.test(props);
  };

  const register = async (e) => {
    e.preventDefault();

    var validPhone = await validatePhoneNumber();
    var validEmail = await validateEmail(email);

    if (validPhone && validEmail && location) {
      SetloadingModal(true);

      var url =
        apiAddress +
        "/api/GoTasteUser/postgotasteuserforkyc?password=" +
        password +
        "&requestId=" +
        approvalId;

      console.log("url: " + url);

      var data = {
        id: "demo",
        firstName: firstname,
        lastName: lastname,
        dateOfBirth: dob,
        currentBalance: 0,
        heldBalance: 0,
        userName: username,
        email: email,
        emailConfirmed: false,
        phoneNumber: phoneNumber,
        isActive: false,
        creationTimestamp: new Date(),
        latitude: location.latitude,
        longitude: location.longitude,
        CityInformationId: location.id,
      };
      axios({
        method: "post",
        url: url,
        data: data,
      })
        .then(function (response) {
          SetloadingModal(false);
          console.log("res: " + response.data);
          if (response.data === "UserName Found") {
            setUserNameFound(true);
          } else if (response.data === "Email Found") {
            setEmailFound(true);
          } else if (
            response.data.includes("go5050") &&
            response.data.includes("Email")
          ) {
            setEmailFound(true);
          } else if (
            response.data.includes("go5050") &&
            response.data.includes("Username")
          ) {
            setUserNameFound(true);
          } else {
            toast.success("Please check your email and verify", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setSuccess(true);
          }

          // window.location.href = "/";
        })
        .catch(function (error) {
          SetloadingModal(false);
          console.log(error);
          if (error.response.status == 404) {
            if (error.response.data.status == "link Deactivated or Canceled") {
              toast.error("Admin cancel or deactivated your account", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          }
        });
    }
  };
  const [returnUrl, setReturnUrl] = useState();
  const [approvalId, setApprovalId] = useState();
  const [isAccountAlreadyCreated, setIsAccountAlreadyCreated] = useState(false);

  const loadData = (props) => {
    SetloadingModal(true);
    axios
      .get(
        apiAddress + "/api/KYCForm/verifyUserRegistrationForKycForm/" + props
      )
      .then((response) => {
        console.log(response.data);
        SetloadingModal(false);
        if (response.data == "NoUserUseThisLink") {
        } else {
          setIsAccountAlreadyCreated(true);
        }
      });
  };

  useEffect(() => {
    var url = searchParams.get("returnurl");
    console.log("url: " + url);
    var res = url?.split("=");
    console.log("res: " + res[1]);
    setApprovalId(res[1]);
    loadData(res[1]);
  }, []);
  const [loadingModal, SetloadingModal] = React.useState(false);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };
  return (
    <div>
      <ToastContainer />
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <div className="divClass"></div>
      {isAccountAlreadyCreated ? (
        <div className={`Successmodal custom-registerForm loginCardKYC`}>
          <div
            className="d-flex align-items-center"
            style={{ flexDirection: "column", gap: "10px", width: "28rem" }}
          >
            <img src={warningImg} alt="" style={{ width: "5rem" }} />
            <h2 style={{ textAlign: "center" }}>
              Link Already used by another user
            </h2>
            <h6
              style={{ cursor: "pointer" }}
              onClick={() => {
                window.location.href = "/login";
              }}
            >
              Go to login
            </h6>
          </div>
        </div>
      ) : (
        <>
          <div className={`${success ? "d-none" : ""}`}>
            <form onSubmit={register}>
              <div className="container custom-registerForm loginCardKYC">
                <h3 className="goTasteH3">Welcome To GoTaste Admin Panel</h3>
                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>First Name</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="text"
                        className="form-control login-info"
                        placeholder="First Name"
                        value={firstname}
                        required
                        onChange={(event) => {
                          setFirstname(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>Last Name</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="text"
                        className="form-control login-info"
                        placeholder="Last Name"
                        value={lastname}
                        required
                        onChange={(event) => {
                          setLastname(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>User Name</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="text"
                        className="form-control login-info"
                        placeholder="User Name"
                        value={username}
                        required
                        onChange={(event) => {
                          setUsername(event.target.value);
                          setUserNameFound(false);
                        }}
                      />
                      <span
                        className={`${userNameFound ? "" : "d-none"}`}
                        style={{ color: "red", fontSize: ".8rem" }}
                      >
                        {" "}
                        User Name Already exists *
                      </span>
                    </div>
                  </div>
                </div>
                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>Date Of Birth</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="date"
                        className="form-control login-info"
                        placeholder="User Name"
                        value={dob}
                        max={maxDate}
                        required
                        onChange={(event) => {
                          setDob(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>Phone Number</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="Number"
                        className="form-control login-info"
                        placeholder="Phone Number"
                        value={phoneNumber}
                        required
                        onChange={(event) => {
                          setPhoneNumber(event.target.value);
                        }}
                      />
                      <span style={{ color: "red" }}>{error}</span>
                    </div>
                  </div>
                </div>

                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>Email</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="email"
                        className="form-control login-info"
                        placeholder="Email"
                        value={email}
                        required
                        onChange={(event) => {
                          setEmail(event.target.value);
                          setEmailFound(false);
                        }}
                      />
                      <span
                        className={`${emailFound ? "" : "d-none"}`}
                        style={{ color: "red", fontSize: ".8rem" }}
                      >
                        {" "}
                        Email Already exists *
                      </span>
                    </div>
                  </div>
                </div>

                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>Location</span>
                  </div>
                  <div className="col-12">
                    <SearchAutocomplete
                      locationDataCallBack={(location) => {
                        setLocation(location);
                      }}
                    />
                  </div>
                </div>

                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span>Password</span>
                  </div>
                  <div className="col-12">
                    <div className="form-group ">
                      <input
                        type="password"
                        className="form-control login-info"
                        placeholder="Password"
                        value={password}
                        required
                        onChange={(event) => {
                          setPassword(event.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className={"row mt-2 "}>
                  <div className="col-12">
                    <span className="text-muted span-text">
                      We’ll call or text you to confirm your number. Standard
                      message and data rates apply. <b>Privacy Policy</b>
                    </span>
                  </div>
                </div>
                <div className={"row mt-4 "}>
                  <div className="col-12 d-flex justify-content-center">
                    <button
                      className="btn btn-success font-weight-bold w-100 "
                      style={{ width: "    width: 100%;", borderRadius: "8px" }}
                      type="submit"
                    >
                      Register
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            className={`${
              success
                ? "Successmodal custom-registerForm loginCardKYC"
                : " d-none"
            }`}
          >
            <div
              className="d-flex align-items-center"
              style={{ flexDirection: "column", gap: "10px", width: "27rem" }}
            >
              <img src={checkImg} alt="" style={{ width: "5rem" }} />
              <h2>Successfully registered </h2>
              {/* <p>Please check your email to verify yourself</p> */}
              <h6
                style={{ cursor: "pointer" }}
                onClick={() => {
                  window.location.href = "/login";
                }}
              >
                Go to login
              </h6>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Register;
